/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Table, TableTypes } from "tvs-unified-lib";
import { FlexButton, Step1Content, Step1Title, TextBoolean } from "../styles";
import { ColumnDef } from "@tanstack/react-table";
import { dataTemplate, rulesTemplate } from "../constant";
import { Fragment } from "react";

interface Props {
  setStep: (step: number) => void;
  handleCancel: () => void;
}

export const Step1 = ({ setStep, handleCancel }: Props) => {
  const templateColumns: ColumnDef<any>[] = [
    {
      header: () => "Data Name",
      enableSorting: false,
      accessorKey: "dataName",
      size: 50,
      cell: ({ getValue }: TableTypes.CellType<any>) => {
        const value = getValue();
        return value;
      },
    },
    {
      header: () => "Description",
      enableSorting: false,
      accessorKey: "description",
      size: 50,
      cell: ({ getValue }: TableTypes.CellType<any>) => {
        const value = getValue();
        return value !== null ? value : "-";
      },
    },
  ];

  const rulesColumns: ColumnDef<any>[] = [
    {
      header: () => "Data Type",
      enableSorting: false,
      accessorKey: "dataType",
      cell: ({ getValue }: TableTypes.CellType<any>) => {
        const value = getValue();
        return value;
      },
    },
    {
      header: () => "Format",
      enableSorting: false,
      accessorKey: "format",
      cell: ({ getValue }: TableTypes.CellType<any>) => {
        const value = getValue();
        return value;
      },
    },
    {
      header: () => "Min. Length",
      enableSorting: false,
      accessorKey: "minLength",
      cell: ({ getValue }: TableTypes.CellType<any>) => {
        const value = getValue();
        return value;
      },
    },
    {
      header: () => "Max. Length",
      enableSorting: false,
      accessorKey: "maxLength",
      cell: ({ getValue }: TableTypes.CellType<any>) => {
        const value = getValue();
        return value;
      },
    },
    {
      header: () => "Alphabets",
      enableSorting: false,
      accessorKey: "alphabets",
      cell: ({ getValue }: TableTypes.CellType<any>) => {
        const value = getValue();
        return <TextBoolean $text={value}>{value}</TextBoolean>;
      },
    },
    {
      header: () => "Number",
      enableSorting: false,
      accessorKey: "number",
      cell: ({ getValue }: TableTypes.CellType<any>) => {
        const value = getValue();
        return <TextBoolean $text={value}>{value}</TextBoolean>;
      },
    },
    {
      header: () => "Alphanumeric",
      enableSorting: false,
      accessorKey: "alphanumeric",
      cell: ({ getValue }: TableTypes.CellType<any>) => {
        const value = getValue();
        return <TextBoolean $text={value}>{value}</TextBoolean>;
      },
    },
  ];

  return (
    <Fragment>
      <Step1Content>
        <Step1Title>Template</Step1Title>
        <Table
          columns={templateColumns}
          data={dataTemplate}
          isLoading={false}
          pagination={{
            pageIndex: 0,
            pageSize: 5,
          }}
          setSorting={() => {}}
          sorting={[]}
          totalRecords={dataTemplate.length}
          enablePagination={false}
          manualSorting={false}
        />
        <Step1Title>Rules</Step1Title>
        <Table
          columns={rulesColumns}
          data={rulesTemplate}
          isLoading={false}
          pagination={{
            pageIndex: 0,
            pageSize: 5,
          }}
          setSorting={() => {}}
          sorting={[]}
          totalRecords={rulesTemplate.length}
          enablePagination={false}
          manualSorting={false}
        />
      </Step1Content>
      <FlexButton $justifyContent="flex-end">
          <Button label="Cancel" variant="outline" onClick={handleCancel}/>
          <Button label="Next" onClick={() => setStep(2)} />
        </FlexButton>
    </Fragment>
  );
};

export default Step1;
